import ComputationData from "./data";

export default function computationDataFromJson(json) {
    return new ComputationData(
        json.id,
        json.voyage_id,
        json.voyage_theyr_id,
        json.state_value,
        json.state_title,
        json.progress,
        json.computation,
        new Date(json['created_at'])
    )
}